module.exports = __webpack_public_path__ + "static/img/unknown.82358572.png";